import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './hooks/useToast';
import { initAnalytics } from './lib/analytics';
import { installEarlyErrorQueue, startSentry } from './lib/sentry';
import ErrorBoundary from './components/ErrorBoundary';

// Both SDKs load AFTER first paint (dynamic import on window load + idle),
// keeping posthog-js and @sentry/react out of the main bundle. Early errors
// and analytics calls are queued and flushed once loaded - see
// lib/sentry.ts and lib/analytics.ts. Both are no-ops without their env keys.
installEarlyErrorQueue();
initAnalytics();
startSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* Root ErrorBoundary is the last line of defence — a render crash
        anywhere in the tree shows the fallback UI instead of a white
        screen. Inner boundaries (e.g. around the map) isolate specific
        subtrees so a tile-load failure doesn't take down the whole app. */}
    <ErrorBoundary boundary="root">
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

